export default "__VITE_ASSET__CJwEe1Fg__"